import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import './Reservation.css';
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import ReservationForm from "../../components/ReservationForm/ReservationForm";
import LanguageContext from '../../context/LanguageContext.js';

const Reservation = () => {
    const { dir } = useContext(LanguageContext);
    const { t } = useTranslation();

    return (
        <main className='main'>
            <Breadcrumb title={t('reservation.title')}/>

            <section className='reservation-section ' dir={dir()}>
                <ReservationForm/>
            </section>
        </main>
    );
};

export default Reservation;
